<template>
    <div class="pS_slider" ref="slider">
        <div class="slider_item"  v-for="product in products" :key="product.id">
            <product-label :product="product" />
            <a :href="'/catalog/item/' + (product.catalog_code ? product.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="slider_item_img">
                <img v-if="product.additional_params" :src="product.list_image" :alt="product.brand_name + ' ' + product.name + ' ' + product.articul" />
            </a>
            <a :href="'/catalog/item/' + (product.catalog_code ? product.catalog_code + '/' : '') + product.id + '/' + product.human_url" class="slider_item_name">{{ product.name }}</a>
            <div class="slider_item_inf">
                <div class="slider_item_inf_box">
                    <div class="slider_item_inf_name">
                        Артикул
                    </div>
                    <div class="slider_item_inf_value">
                        {{ product.articul }}
                    </div>
                </div>
                <div class="slider_item_inf_box">
                    <div class="slider_item_inf_name">
                      Код
                    </div>
                    <div class="slider_item_inf_value">
                        {{ product.code }}
                    </div>
                </div>
                <div class="slider_item_inf_box">
                    <div class="slider_item_inf_name">
                        в наличии
                    </div>
                    <div class="slider_item_inf_value">
                        {{ product.smart_stock }}
                    </div>
                </div>
            </div>
            <div class="slider_item_price" v-if="product.current_price && product.current_price.amount > 0">
                <div class="slider_item_price_value">
                    <money :price="product.current_price" />
                </div>
                <div class="slider_item_price_old" v-if="product.has_discount">
                    <money :price="product.base_price" />
                </div>
            </div>
            <div v-if="product.has_stock && !mode">
                <buy-button :product="product" mode="slider"/>
            </div>
            <div v-if="mode=='external'">
                <buy-button :product="product" mode="external"/>
            </div>

        </div>
    </div>
</template>

<script>
    import BuyButton from "./BuyButton";
    import Money from "../core/Money";
    import ProductLabel from "./ProductLabel";

    export default {
        name: 'ProductSlider',
        components: {BuyButton, Money, ProductLabel},
        props: ['products', 'mode'],
        mounted() {
            window.$(this.$refs.slider).slick({
                slidesToShow: 3,
                slidesToScroll: 3,
                speed: 1000,
                dots: false,
                infinite: true,
                arrows: true,
                swipe: true,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 951,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 621,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    }
</script>

<style scoped>

</style>
